import ErrorPage404 from './ErrorPage404';

export default ErrorPage404;
